import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
} from '../../../../components';

import './style.scss';
import '../../../Node/KPQuestion/Teaser/style.scss';

const NavigationMainMenuSubComponentKP = ({ items = [], active, setActive }) => {
  const SCROLL_DIRECTION = {
    DOWN: 'down',
    UP: 'up',
  };

  const { t } = useTranslation();
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);

  const renderMenu = (itemToMap) => {
    return itemToMap.get('subtree').map((subItem) => {
      const subItemHref = subItem.getIn(['link', 'url']);
      const subItemTitle = subItem.getIn(['link', 'title'], '');
      return (
        <CoreLink className="NodeKPQuestionPageTeaser__link" href={subItemHref} onClick={() => setActive(false)}>
          <div className="NodeKPQuestionPageTeaser">
            <div className="NodeKPQuestionPageTeaser__icon">
              <i className="icon icon-arrow-right icon-variant-2" />
            </div>
            <WysiwygField
              className="NodeKPQuestionPageTeaser__heading"
              html={subItemTitle}
            />
          </div>
        </CoreLink>
      );
    });
  };

  const handleContainerScroll = ({ currentTarget }) => {
    const newScrollTop = currentTarget && currentTarget.scrollTop || 0;
    if (newScrollTop > scrollTop) {
      setScrollDirection(SCROLL_DIRECTION.DOWN);
    } else if (newScrollTop < scrollTop) {
      setScrollDirection(SCROLL_DIRECTION.UP);
    }

    setScrollTop(newScrollTop <= 0 ? 0 : newScrollTop);
  }

  return (
    <div className={c('NavigationMainMenuDesktop__container', {
      'NavigationMainMenuDesktop__container--scrollingUp': scrollDirection === SCROLL_DIRECTION.UP,
      'NavigationMainMenuDesktop__container--scrollingDown': scrollDirection === SCROLL_DIRECTION.DOWN,
      'NavigationMainMenuDesktop__container--hovered': active,
      'NavigationMainMenuDesktop__container--inactive': !active,
    })}
      onScroll={handleContainerScroll}
    >
      <div className="NavigationMainMenuDesktop__container__scrollTop" />
      <Container>
        <div className="row">
          {items.map((item, index) => {
            const title = item.getIn(['link', 'title'], 'Untitled');
            const description = item.getIn(['link', 'description']);
            const mobileSubtreeClasses = c('mobile-subtree-display', {
              'active': activeMenuIndex === index,
            });
            return (
              <>
                <div className="col-12 col-md-6">
                  <div className="NavigationMainMenuDesktop__title" onClick={(e) => setActiveMenuIndex(index)}>
                    <h3>{title}</h3>
                    {description && <p>{description}</p>}
                    <i className="icon menu-item-icon icon-chevron icon-variant-1" />
                  </div>

                  <div className="NavigationMainMenuDesktop__subtree_holder">
                    {renderMenu(item)}
                  </div>
                </div>
                <div className={mobileSubtreeClasses}>
                  <div className="menu-item-back" onClick={() => setActiveMenuIndex(null)}>
                    <i className="icon menu-item-back-icon icon-chevron icon-variant-2" />
                    {t('back')}
                  </div>
                  <h3>{title}</h3>
                  {renderMenu(item)}
                </div>
              </>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default NavigationMainMenuSubComponentKP;
